import { render, staticRenderFns } from "./Affix.vue?vue&type=template&id=39d2774a&"
import script from "./Affix.vue?vue&type=script&lang=js&"
export * from "./Affix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports